const firebaseConfigLocal = {
    apiKey: "AIzaSyCiXWdV6Lja8Z-dRc3c5tWoCF0JjUr6jD4",
    authDomain: "ent-75868.firebaseapp.com",
    databaseURL: "https://ent-75868.firebaseio.com",
    projectId: "ent-75868",
    storageBucket: "ent-75868.appspot.com",
    messagingSenderId: "12756001029",
    appId: "1:12756001029:web:246bb8d2ddb075b388176c"  
};

export default firebaseConfigLocal;